export const T = {
  en_GB: {
    country: "Country",
    language: "Language",
    costCategory: "Cost Category",
    owner: "Owner",
    clientType: "Client Type",
    team: "Team",
    deletedTeam: "Deleted team",
    favourite: "Favourites",
    email: "Email",
    mobilePhone: "Mobile Phone",
    orgId: "Org Identifier",
    externalId: "External ID",
    ageOver: "Age over",
    ageBelow: "Age below",
    cashOver: "Cash over",
    fieldOver: (name: string) => `${name} over`,
    lastClientCommunication: "Last Client Communication",
    typePerson: "Person",
    typeCompany: "Company",
    typeGroup: "Group",
    meCurrentUser: "Me (current user)",
  },
  nb_NO: {
    country: "Land",
    language: "Språk",
    costCategory: "Kostnadskategori",
    owner: "Eier",
    clientType: "Kundetype",
    team: "Team",
    deletedTeam: "Slettet team",
    favourite: "Favoritter",
    email: "E-post",
    mobilePhone: "Mobiltelefon",
    orgId: "Org.nummer",
    externalId: "Ekstern ID",
    ageOver: "Alder over",
    ageBelow: "Alder under",
    cashOver: "Kontanter over",
    fieldOver: (name: string) => `${name} over`,
    lastClientCommunication: "Siste kundekommunikasjon",
    typePerson: "Person",
    typeCompany: "Selskap",
    typeGroup: "Gruppe",
    meCurrentUser: "Meg (nåværende bruker)",
  },
} as const;

export const ACTIVITY_DATE_LABELS = {
  en_GB: {
    lastLogin: "Last Login",
    lastInfoUpdated: "Last Updated",
    lastFlowActivity: "Last Flow Activity",
    lastFlowCompleted: "Last Flow Completed",
    lastAccountSynced: "Last Account Synced",
    lastSignedDocument: "Last Signed Document",
    createdAt: "Created",
  },
  nb_NO: {
    lastLogin: "Siste innlogging",
    lastInfoUpdated: "Sist oppdatert",
    lastFlowActivity: "Siste flytaktivitet",
    lastFlowCompleted: "Siste fullførte flyt",
    lastAccountSynced: "Siste kontosynkronisering",
    lastSignedDocument: "Siste signerte dokument",
    createdAt: "Opprettet",
  },
} as const;
